import { Component, OnInit } from '@angular/core'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { BehaviorSubject } from 'rxjs'

@Component({
  selector: 'se-po-review-docs',
  templateUrl: './review-docs.component.html',
  styleUrls: ['./review-docs.component.scss'],
  standalone: false,
})
export class ReviewDocsComponent implements OnInit {
  public storeLoaded = false
  public child: any
  public parent: any
  public guardianInvites: any[] = []

  constructor(public store: StoreService) { }

  ngOnInit(): void {
    this.store.childInfo = {
      name: {
        first: 'John',
        last: 'Doe',
      },
      dateOfBirth: '2023-10-01',
      gender: 'male',
      gradYear: '2099'
    }
    this.store.accountInfo = {
      dateOfBirth: '2023-10-01',
      email: 'test@test.com',
      firstName: 'Parent',
      gender: 'male',
      lastName: 'Name',
      phone: '1234567890'
    }
    this.store.draftGuardianInvites = new BehaviorSubject<any[]>([{email: 'new@guradina.com', access: 'manager'}])
    this.store.basePath = 'se-household-setup'
  }
}
